const irregular = new Map([
  ['midwife', 'midwives'],
  ['handyperson', 'handypeople'],
  ['person', 'people'],
  ['man', 'men'],
  ['woman', 'women'],
])

// These role names are compounds whose plural is not formed at the end.
const compoundPlurals = new Map([
  ['master of ceremonies', 'masters of ceremonies'],
  ['notary public', 'notaries public'],
])

function pluralLastWord(value) {
  const words = value.split(' ')
  const last = words.at(-1)
  const lowercase = last.toLocaleLowerCase('en-GB')
  const plural = /^[A-Z]{2,}$/.test(last) ? `${last}s` : irregular.get(lowercase)
    || (/[^aeiou]y$/i.test(lowercase) ? `${last.slice(0, -1)}ies`
      : /(?:s|x|z|ch|sh)$/i.test(lowercase) ? `${last}es`
        : `${last}s`)
  return [...words.slice(0, -1), plural].join(' ')
}

export function professionNameInSentence(name) {
  return String(name).split(' ').map(word => /^[A-Z]{2,}$/.test(word) ? word : word.toLocaleLowerCase('en-GB')).join(' ')
}

export function pluralProfessionName(name) {
  const lowercase = professionNameInSentence(name)
  if (compoundPlurals.has(lowercase)) return compoundPlurals.get(lowercase)
  // Most "and" names describe the service, not two occupations: a speech
  // and language therapist is not a "speechs and language therapists".
  if (['carpenter and joiner', 'painter and decorator', 'vehicle valeter and detailer'].includes(lowercase)) {
    return lowercase.split(' and ').map(pluralLastWord).join(' and ')
  }
  return pluralLastWord(lowercase)
}

export function pluralProfessionNameAtStart(name) {
  const plural = pluralProfessionName(name)
  return plural.charAt(0).toLocaleUpperCase('en-GB') + plural.slice(1)
}
